import md5 from "md5";
// const keyMpadding = {
//   development: "p*Tp*NI#TS",
//   testing: "p*Tp*NI#TS",
//   production: "p*Tp*NI#TS",
// };
const keyMpadding = {
  development: "p*Tp*NI#TS",
  testing: "v*Tp#NI*TS",
  production: "p*Tp*NI#TS",
};
export const md5SignEncode = (str, env) => {
  return md5(
    `${str}&key=${
      keyMpadding[env || process.env.NODE_ENV] || keyMpadding.development
    }`
  );
};
export const getPosType = () => {
  var agent = navigator.userAgent.toLowerCase();
  console.log(agent);
  // var isMac = /macintosh|mac os x/i.test(navigator.userAgent);
  if (agent.indexOf("windows") >= 0 || agent.indexOf("wow32") >= 0) {
    console.log("这是windows系统");
  }
  if (agent.indexOf("mac") >= 0 || agent.indexOf("wow64") >= 0) {
    console.log("这是mac系统");
  }
  if (agent.indexOf("iphone") >= 0 || agent.indexOf("wow64") >= 0) {
    console.log("这是iphone系统");
  }
  if (agent.indexOf("android") >= 0 || agent.indexOf("wow64") >= 0) {
    console.log("这是android系统");
  }
  // if (isMac) {
  //   console.log("这是mac系统");
  // }
};

// ========================= wjj到此一游 ==================================
// 邮箱还是手机的判断
export const mobileEmailDetection = (phoneAndEmal) => {
  let filg = "";
  if (phoneAndEmal.includes("@")) {
    filg = "2";
  } else {
    filg = "1";
  }
  return filg;
};
// 获取手机型号等信息
export const equipment = () => {
  const userAgentStr = navigator.userAgent;
  console.log(userAgentStr);
  let deviceName = "";
  let deviceId = "";
  let browser = "";
  let browserId = "";
  let flag = userAgentStr.match(
    /Mac|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows/i
  );
  deviceName = flag[0];
  console.log(deviceName);
  if (deviceName === "Windows") {
    deviceId = userAgentStr.split("Windows NT ")[1].split(";")[0];
  } else if (deviceName === "Mac") {
    deviceId = userAgentStr.split("Mac OS X ")[1].split(")")[0];
  } else if (deviceName === "iPhone") {
    deviceId = userAgentStr.split("iPhone OS ")[1].split(" ")[0];
  } else if (deviceName === "iPad") {
    deviceId = userAgentStr.split("iPad; CPU OS ")[1].split(" ")[0];
  } else if (deviceName === "Android") {
    deviceId = userAgentStr.split("Android ")[1].split(";")[0];
  }
  // 判断浏览器的版本
  // 谷歌
  if (/Chrome/.test(userAgentStr)) {
    browserId = userAgentStr.match(/Chrome\/([\d.]+)/)[1];
    browser = "Chrome";
  }

  // edg
  if (/Edg/.test(userAgentStr)) {
    browserId = userAgentStr.match(/Edg\/([\d.]+)/)[1];
    browser = "Edge";
  }

  // 火狐
  if (/Firefox/.test(userAgentStr)) {
    browserId = userAgentStr.match(/Firefox\/([\d.]+)/)[1];
    browser = "Firefox";
  }

  // 苹果
  if (/Safari/.test(userAgentStr) && !/Chrome/.test(userAgentStr)) {
    browserId = userAgentStr.match(/Version\/([\d.]+)/)[1];
    browser = "Safari";
  }

  // IE
  if (/Trident/.test(userAgentStr)) {
    const tridentVersionMatch = userAgentStr.match(/Trident\/([\d.]+)/);
    if (tridentVersionMatch) {
      const ieVersion = parseInt(tridentVersionMatch[1]) + 4;
      browserId = ieVersion.toString();
      browser = "IE";
    }
  }

  deviceId = md5(deviceName + deviceId + browser + browserId);

  return {
    deviceId,
    deviceName,
  };
};
